<script setup lang="ts">
import { CommandDialog } from "~/layers/ui/components/command";

import { useMagicKeys } from "@vueuse/core";
import { ref, watch } from "vue";
import Input from "~/layers/ui/components/input/Input.vue";
import { Search } from "lucide-vue-next";
import Button from "~/layers/ui/components/button/Button.vue";

const open = ref(false);
const searchQuery = ref("");

const { Meta_K, Ctrl_K } = useMagicKeys({
  passive: false,
  onEventFired(e) {
    if (e.key === "j" && (e.metaKey || e.ctrlKey)) e.preventDefault();
  },
});

watch([Meta_K, Ctrl_K], (v) => {
  if (v[0] || v[1]) handleOpenChange();
});

function handleOpenChange() {
  open.value = !open.value;
}

function search() {
  navigateTo("/search?query=" + searchQuery.value);

  searchQuery.value = "";
  open.value = false;
}
</script>

<template>
  <div>
    <button
      class="flex h-10 w-full relative rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none placeholder:text-gray-400 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      @click="open = true"
    >
      <span class="text-sm tracking-tight text-gray-400"
        >Search X handle, X ID ...</span
      >
      <kbd
        class="pointer-events-none absolute right-2 inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100"
      >
        <span class="text-xs">⌘</span>K
      </kbd>
    </button>

    <CommandDialog v-model:open="open">
      <form @submit.prevent="search">
        <div class="flex mt-1 items-center pr-12 justify-between">
          <div class="relative">
            <Search
              :size="20"
              class="absolute text-gray-500 left-2 top-2"
            ></Search>
            <Input
              v-model="searchQuery"
              placeholder="Search anything"
              class="border-0 focus:border-0 focus-visible:ring-0 ring-0 pl-9"
            />
          </div>
          <div>
            <Button size="sm">Look up</Button>
          </div>
        </div>
      </form>

      <div class="my-4 px-4">
        <p class="text-xs text-gray-500">Entities that require exact match</p>
        <p class="text-sm text-gray-600 mt-2">
          X user ID, Creator ID, Wallet ID, Tweet ID
        </p>
      </div>
    </CommandDialog>
  </div>
</template>
